export default __webpack_public_path__ + "static/media/list.f8411e3e.svg";